export const copywritingTypeList = [
  {
    value: "产品种草",
    label: "产品种草",
  },
  {
    value: "产品测评",
    label: "产品测评",
  },
  {
    value: "选购攻略",
    label: "选购攻略",
  },
];

export const copywritingStyleList = [
  {
    value: "生活体验",
    label: "生活体验",
  },
  {
    value: "年轻活泼",
    label: "年轻活泼",
  },
  {
    value: "专业权威",
    label: "专业权威",
  },
  {
    value: "文艺清新",
    label: "文艺清新",
  },
];

export const IndustryList = [
  {
    value: "家电行业",
    label: "家电行业",
  },
  {
    value: "3C行业",
    label: "3C行业",
  },
  {
    value: "美妆行业",
    label: "美妆行业",
  },
  {
    value: "快消行业",
    label: "快消行业",
  },
  {
    value: "汽车行业",
    label: "汽车行业",
  },
 
  {
    value: "其他行业",
    label: "其他行业",
  },
  

];

export const subIndustryList = {
  家电行业: [
    {
      value: "电视",
      label: "电视",
    },
    {
      value: "空调",
      label: "空调",
    },
    {
      value: "洗烘",
      label: "洗烘",
    },
    {
      value: "冰箱",
      label: "冰箱",
    },
    {
      value: "烟灶",
      label: "烟灶",
    },
    {
      value: "洗碗机",
      label: "洗碗机",
    },
    {
      value: "蒸烤箱",
      label: "蒸烤箱",
    },
    {
      value: "热水器",
      label: "热水器",
    },
    {
      value: "净水器",
      label: "净水器",
    },
    {
      value: "小家电",
      label: "小家电",
    },
  ],
  "3C行业": [
    {
      value: "手机",
      label: "手机",
    },
    {
      value: "笔记本",
      label: "笔记本",
    },
  ],
  美妆行业: [
    {
      value: "美妆",
      label: "美妆",
    },
  ],
  快消行业: [
    {
      value: "快消",
      label: "快消",
    },
  ],
  汽车行业: [
    {
      value: "汽车",
      label: "汽车",
    },
  ],
  其他行业: [
    {
      value: "其他",
      label: "其他",
    },
  ],
};

export const targetAudienceList = [
  {
    value: "大众用户",
    label: "大众用户",
  },
  {
    value: "年轻女性",
    label: "年轻女性",
  },
  {
    value: "年轻男性",
    label: "年轻男性",
  },
  {
    value: "母婴群体",
    label: "母婴群体",
  },
  {
    value: "家庭用户",
    label: "家庭用户",
  },
  {
    value: "学生党",
    label: "学生党",
  },
  {
    value: "上班族",
    label: "上班族",
  },
  {
    value: "中产阶级",
    label: "中产阶级",
  },
];



// WEBPACK FOOTER //
// ./src/utils/constants.js